/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_ViewerInputs */

const en_sidebar_viewer = /** @type {(inputs: Sidebar_ViewerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Viewer`)
};

const ko_sidebar_viewer = /** @type {(inputs: Sidebar_ViewerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 뷰어`)
};

const ja_sidebar_viewer = /** @type {(inputs: Sidebar_ViewerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONビューアー`)
};

/**
* | output |
* | --- |
* | "JSON Viewer" |
*
* @param {Sidebar_ViewerInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sidebar_viewer = /** @type {((inputs?: Sidebar_ViewerInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_ViewerInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sidebar_viewer(inputs)
	if (locale === "ko") return ko_sidebar_viewer(inputs)
	return ja_sidebar_viewer(inputs)
});